import React, { useState, useMemo } from 'react'
export const useConstant = (fn) => {
	const ref = React.useRef()
	if (!ref.current) {
		ref.current = { v: fn() }
	}
	return ref.current.v
}
